import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import stripeApiController from "services/stripe.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const stripeErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const StripeUpdatekeysApi = createAsyncThunk("stripe/updatekeys", async (formValues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .updatekeys(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "updatekeys"))
      .catch((error) => HandleError(thunkAPI, error, "updatekeys"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StripeSetupApi = createAsyncThunk("stripe/setup", async (formValues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .setup(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "setup"))
      .catch((error) => HandleError(thunkAPI, error, "setup"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StripeCardPaymentApi = createAsyncThunk("stripe/cardpayment", async (formValues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .cardpayment(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "cardpayment"))
      .catch((error) => HandleError(thunkAPI, error, "cardpayment"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StripeOauthApi = createAsyncThunk("stripe/Oauth", async (formValues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .oauth(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Oauth"))
      .catch((error) => HandleError(thunkAPI, error, "Oauth"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StripePaymentStore = createAsyncThunk("stripepayment/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const StripePaymentApi = createAsyncThunk("stripe/payment", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .stripepayment(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "payment"))
      .catch((error) => HandleError(thunkAPI, error, "payment"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const StripePaymentFailedApi = createAsyncThunk("stripe/paymentdfailed", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await stripeApiController
      .stripepaymentfailed(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "paymentdfailed"))
      .catch((error) => HandleError(thunkAPI, error, "paymentdfailed"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

const initialState = {
  isOpenedAddForm: "",
  isStripePaymentStatus: "",
  isOnlineStripePayment: "",
  isStripeOauth: "",
  isStripeOauthError: "",
  isStripeUpdatekeysApi: "",
  isStripeUpdatekeysError: "",
  isStripeSetupApi: "",
  isStripeSetupError: "",
  isStripeCardPaymentApi: "",
  isStripeCardPaymentError: "",
  isStripePaymentApi: "",
  isStripePaymentError: "",
  isStripePaymentFailedApi: "",
  isStripePaymentFailedError: "",
  isListView:"",
  isPaymentStoreError: "",
  isStripeFormErrorSwal: false,
  isApiStatus: {
    StripeUpdatekeysApi: "",
    StripeSetupApi: "",
    StripeCardPaymentApi: "",
    StripeOauthApi: "",
    StripePaymentApi: "",
    StripePaymentFailedApi: "",
    StripePaymentStore : "",
  },
};

const stripeSlice = createSlice({
  name: "stripe",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenAddStripeForm: (state = initialState) => {
      state.isOpenedAddForm = "open";
    },
    CloseAddStripeForm: (state = initialState) => {
      state.isOpenedAddForm = "";
    },
    StripePaymentStatus: (state, action) => {
      state.isStripePaymentStatus = action.payload;
    },
    OnlineStripePayment: (state, action) => {
      state.isOnlineStripePayment = action.payload;
    },
    StripeFormErrorSwal: (state, action) => {
      state.isStripeFormErrorSwal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(StripePaymentStore.pending, (state) => {
        state.isPaymentStoreError = "";
        state.isApiStatus = { ...state.isApiStatus, StripePaymentStore: "loading" };
      })
      .addCase(StripePaymentStore.fulfilled, (state, action) => {
        if (state.isListView && state.isListView.data) {
          state.isListView.data = [action.payload, ...state.isListView.data];
        } else {
          state.isListView = { data: [action.payload] };
        }
        state.isApiStatus = { ...state.isApiStatus, StripePaymentStore: "succeeded" };
      })
      .addCase(StripePaymentStore.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripePaymentStore: "failed" };
        state.isPaymentStoreError = stripeErrorMessage(action, "Unable to save Stripe payment.");
      })
      .addCase(StripeSetupApi.pending, (state) => {
        state.isStripeSetupError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeSetupApi: "loading" };
      })
      .addCase(StripeSetupApi.fulfilled, (state, action) => {
        state.isStripeSetupApi = action.payload;
        state.isStripeSetupError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeSetupApi: "succeeded" };
      })
      .addCase(StripeSetupApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeSetupApi: "failed" };
        state.isStripeSetupError = stripeErrorMessage(action, "Unable to save Stripe settings.");
      })
      .addCase(StripeOauthApi.pending, (state) => {
        state.isStripeOauthError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeOauthApi: "loading" };
      })
      .addCase(StripeOauthApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeOauthApi: "succeeded" };
        state.isStripeOauth = action.payload;
        state.isStripeOauthError = "";
      })
      .addCase(StripeOauthApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeOauthApi: "failed" };
        state.isStripeOauthError = stripeErrorMessage(action, "Unable to connect Stripe.");
      })
      .addCase(StripeUpdatekeysApi.pending, (state) => {
        state.isStripeUpdatekeysError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeUpdatekeysApi: "loading" };
      })
      .addCase(StripeUpdatekeysApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeUpdatekeysApi: "succeeded" };
        state.isStripeUpdatekeysApi = action.payload;
        state.isStripeUpdatekeysError = "";
      })
      .addCase(StripeUpdatekeysApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeUpdatekeysApi: "failed" };
        state.isStripeUpdatekeysError = stripeErrorMessage(action, "Unable to update Stripe keys.");
      })
      .addCase(StripeCardPaymentApi.pending, (state) => {
        state.isStripeCardPaymentError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeCardPaymentApi: "loading" };
      })
      .addCase(StripeCardPaymentApi.fulfilled, (state, action) => {
        state.isStripeCardPaymentApi = action.payload;
        state.isStripeCardPaymentError = "";
        state.isApiStatus = { ...state.isApiStatus, StripeCardPaymentApi: "succeeded" };
      })
      .addCase(StripeCardPaymentApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripeCardPaymentApi: "failed" };
        state.isStripeCardPaymentError = stripeErrorMessage(action, "Unable to process Stripe card payment.");
      })
      .addCase(StripePaymentApi.pending, (state) => {
        state.isStripePaymentError = "";
        state.isApiStatus = { ...state.isApiStatus, StripePaymentApi: "loading" };
      })
      .addCase(StripePaymentApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripePaymentApi: "succeeded" };
        state.isStripePaymentApi = action.payload;
        state.isStripePaymentError = "";
      })
      .addCase(StripePaymentApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripePaymentApi: "failed" };
        state.isStripePaymentError = stripeErrorMessage(action, "Unable to process Stripe payment.");
      })
      .addCase(StripePaymentFailedApi.pending, (state) => {
        state.isStripePaymentFailedError = "";
        state.isApiStatus = { ...state.isApiStatus, StripePaymentFailedApi: "loading" };
      })
      .addCase(StripePaymentFailedApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripePaymentFailedApi: "succeeded" };
        state.isStripePaymentFailedApi = action.payload;
        state.isStripePaymentFailedError = "";
      })
      .addCase(StripePaymentFailedApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, StripePaymentFailedApi: "failed" };
        state.isStripePaymentFailedError = stripeErrorMessage(action, "Unable to record failed Stripe payment.");
      });
  }
});

// Action creators are generated for each case reducer function
export const { reset, OpenAddStripeForm, CloseAddStripeForm, StripePaymentStatus, OnlineStripePayment,StripeFormErrorSwal } = stripeSlice.actions;
export default stripeSlice.reducer;
